module.exports = __webpack_public_path__ + "img/one.13076523.png";